import * as React from "react";

const SvgErrowNotification = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 25 24"
  >
    <path
      fill="currentColor"
      fillOpacity={0.92}
      fillRule="evenodd"
      d="M3.194 8.093a9.7 9.7 0 0 0-.787 3.9q0 2.074.787 3.899a10.1 10.1 0 0 0 2.137 3.174q1.35 1.35 3.174 2.137a9.7 9.7 0 0 0 3.9.787 9.7 9.7 0 0 0 3.898-.787 10.1 10.1 0 0 0 3.174-2.137q1.35-1.35 2.137-3.174a9.7 9.7 0 0 0 .788-3.9q0-.674-.088-1.324a9 9 0 0 0-.262-1.275q-.375.4-.825.712-.45.314-.95.513.05.35.088.687t.037.688q0 3.348-2.324 5.673-2.325 2.325-5.674 2.325t-5.673-2.325-2.325-5.674q0-3.348 2.325-5.673 2.324-2.324 5.673-2.324.35 0 .688.037.337.038.687.087a4.8 4.8 0 0 1 .512-.95q.312-.45.713-.824a9 9 0 0 0-1.275-.263 10 10 0 0 0-1.325-.087 9.7 9.7 0 0 0-3.899.787A10.1 10.1 0 0 0 5.331 4.92Q3.98 6.27 3.194 8.093m13.084.025a2.9 2.9 0 0 0 2.125.875q1.25 0 2.124-.875a2.9 2.9 0 0 0 .875-2.124q0-1.25-.875-2.124a2.9 2.9 0 0 0-2.124-.875q-1.25 0-2.125.875a2.9 2.9 0 0 0-.875 2.124q0 1.25.875 2.124m-4.873-1.124h2v6.998h-2zm1.999 9.997a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgErrowNotification;
